
import { contractApi } from "@/axios";
//获取邮件信息
export function getEmailPage(params, data) {
    return contractApi({
        url: '/mail/page',
        method: 'post',
        data: data,
        params: params
    })
}
//查看邮件内容
export function previewContent(id) {
    return contractApi({
        url: '/mail/preview/' + id,
        method: 'get'
    })
}
//下载邮件附件
export function downloadEmail(id) {
    return contractApi({
        url: '/mail/attachment/' + id,
        method: 'get',
        responseType: 'blob', // 设置响应类型为 blob
    })
}
//修改邮箱
export function editEmail(data) {
    return contractApi({
        url: '/mail/edit',
        method: 'put',
        data: data
    })
}
//取消邮寄
export function cancelSend(id) {
    return contractApi({
        url: '/mail/cancel/' + id,
        method: 'get'
    })
}
//现在邮寄
export function sendNow(id) {
    return contractApi({
        url: '/mail/send/' + id,
        method: 'get',
    });
}